import { Property as impProperty, AuditStdImport, GetSeason } from './auditstd-import-model'
import DateTime from 'typescript-dotnet-es6/System/Time/DateTime'
import { CorporateDateRules } from '../utilities/corporateDateRules'
import { ImportValidator } from '../utilities/import-validator'
import { format } from 'typescript-dotnet-es6/System/Text/Utility'
import { AddDaysToDate, RIAHelper } from '../../../../core'
import { DateTimeExtension } from './date-time.extension'

export class AuditStdEdit {
  GetSeasonRange(initialEnd:Date): { earliestStart: DateTime; latestEnd: DateTime } {
    let maxEnd = AddDaysToDate( DateTime.today,330);
    let minStart = AddDaysToDate( DateTime.today,1);
    let rtn = { earliestStart: minStart, latestEnd:  new DateTime(initialEnd) }
    for (const p of this.property) {
      if(p.Season1StartDate!=null && p.Season1StartDate.toJsDate()<rtn.earliestStart.toJsDate() && p.Season1StartDate.toJsDate()> minStart.toJsDate()){
        rtn.earliestStart = p.Season1StartDate;
      }
      let seasonEnd = p.Season8EndDate || p.Season7EndDate || p.Season6EndDate || p.Season5EndDate ||p.Season4EndDate ||p.Season3EndDate ||p.Season2EndDate ||p.Season1EndDate;
      if(seasonEnd!=null && seasonEnd.toJsDate()>rtn.latestEnd.toJsDate()){
        if(seasonEnd.toJsDate()<maxEnd.toJsDate() ){
          rtn.latestEnd = seasonEnd;
        }
        else{
          rtn.latestEnd = maxEnd;
        }
      }
    }
    return rtn;
  }
  QuickAuditID: string;
  QuickAuditChannelID: number;
  QuickAudit: boolean;
  AuditAmadeus: boolean;
  AuditApollo: boolean;
  AuditGalileo: boolean;
  AuditSabre: boolean;
  AuditWorldspan: boolean;
  CustomerAccountID: string = "";
  LanyonAccountID: string = "";
  ContractYear: string = "";
  SabrePCC: string = "";
  RACFilters: string = "";
  AccountName: string = "";
  AccountType: string = "";
  LengthofStay: number = 1;
  NumberOfOccupants: number = 1;
  ScheduledRunDate: Date;
  RequiresApproval: boolean;
  AuditApproved: boolean;
  ApprovedBy: string = "";

  sessionGuid: string = "";
  StoredFileName: string = "";
  SendNotifications: boolean;
  NotificationTemplateID: string;
  NotificationTemplateName: string = "";
  ImportResults: ImportResults;
  property: Property[];
  NextQuickAuditID: string = "";

  AuditContactEmailAddress: string = "";
  ReverseAuditTmpCustomerID: number;
  now: () => DateTime = () => { return DateTime.now };
  GetSubmitModel() {
    let dat: AuditStdEdit = this;
    let data = { ...dat };
    data.ScheduledRunDate = <any>RIAHelper.CreateRIADate(data.ScheduledRunDate);//this still works after the move to RIAController => ScheduledRunDate: "/Date(1651665600000-0500)/"
    data.property = [];
    dat.property.forEach(origp => {
      let p: Property = <Property>{ ...origp };
      Property.PrepareDates(p);
      data.property.push(p);
    });
    return data;
  }
  static copy(dat: AuditStdEdit): AuditStdEdit {
    let n: any = { ...dat };
    n.__proto__ = (<any>dat).__proto__;
    n.property = [];
    dat.property.forEach(p => n.property.push(Property.copy(p)));
    return n;
  }

  constructor(data: AuditStdImport, quickAudit: boolean, AuditContactEmailAddress: string) {
    this.QuickAudit = quickAudit;
    this.AuditAmadeus = data.AuditAmadeus;
    this.AuditApollo = data.AuditApollo;
    this.AuditGalileo = data.AuditGalileo;
    this.AuditSabre = data.AuditSabre;
    this.AuditWorldspan = data.AuditWorldspan;
    this.CustomerAccountID = data.CustomerAccountID;
    this.LanyonAccountID = data.LanyonAccountID;
    this.ContractYear = data.ContractYear;
    this.SabrePCC = data.SabrePCC;
    this.RACFilters = data.RACFilters;
    this.AccountName = data.AccountName;
    this.AccountType = data.AccountType;
    this.property = [];
    this.NextQuickAuditID = data.NextQuickAuditId;
    this.AuditContactEmailAddress = AuditContactEmailAddress;


    let properties: impProperty[] = data.property;
    properties.forEach((p: impProperty, index: number) => {

      let property: Property = new Property();

      property.now = this.now;
      property.HotelChainCode = p.HotelChainCode;
      property.ParentHotelName = p.ParentHotelName;
      property.HotelCRSPropertyCode = p.HotelCRSPropertyCode;
      property.PropertyName = p.PropertyName;
      property.PropertyAddress = p.PropertyAddress;
      property.PropertyCity = p.PropertyCity;
      property.PropertyStateProvince = p.PropertyStateProvince;
      property.PropertyPostalCode = p.PropertyPostalCode;
      property.PropertyCountry = p.PropertyCountry;
      property.PropertyPhone = p.PropertyPhone;
      property.ContactName = p.ContactName;
      property.ContactEMail = p.ContactEMail.trim();
      property.ProcessAmadeus = p.ProcessAmadeus;
      property.ProcessApollo = p.ProcessApollo;
      property.ProcessGalileo = p.ProcessGalileo;
      property.ProcessSabre = p.ProcessSabre;
      property.ProcessWorldspan = p.ProcessWorldspan;
      property.AmadeusChainCode = p.AmadeusChainCode;
      property.AmadeusPropCode = p.AmadeusPropCode;
      property.AmadeusRateAccessCode = p.AmadeusRateAccessCode;
      property.ApolloChainCode = p.ApolloChainCode;
      property.ApolloPropCode = p.ApolloPropCode;
      property.ApolloRateAccessCode = p.ApolloRateAccessCode;
      property.GalileoChainCode = p.GalileoChainCode;
      property.GalileoPropCode = p.GalileoPropCode;
      property.GalileoRateAccessCode = p.GalileoRateAccessCode;
      property.SabreChainCode = p.SabreChainCode;
      property.SabrePropCode = p.SabrePropCode;
      property.SabreRateAccessCode = p.SabreRateAccessCode;
      property.WorldspanChainCode = p.WorldspanChainCode;
      property.WorldspanPropCode = p.WorldspanPropCode;
      property.WorldspanRateAccessCode = p.WorldspanRateAccessCode;
      property.RateCurrency = p.RateCurrency;
      property.AutoExtractSeasons = p.AutoExtractSeasons;
      property.RoomType = p.RoomType;
      property.LRA = p.LRA;
      property.EditEmail = p.ContactEMail.trim().length == 0;
      property.BidAmenityBreakfast= p.BidAmenityBreakfast;
      property.BidAmenityInternet= p.BidAmenityInternet;
      property.BidAmenityParking = p.BidAmenityParking;
      property.BidAmenityAirport = p.BidAmenityAirport;
      property.BidAmenityLocalShuttle = p.BidAmenityLocalShuttle;
      property.BidPolicyCancellation = p.BidPolicyCancellation;

      property.TempAuditPropertyID = p.TempAuditPropertyID;
      property.LoadedFromOriginal = p.LoadedFromOriginal;
      property.OriginalAuditPropertyID = p.OriginalAuditPropertyID;
      if(p.ImportStatus && p.ImportStatus.Errors){
        property.Errors = p.ImportStatus.Errors.Error.length?p.ImportStatus.Errors.Error:[<any>p.ImportStatus.Errors.Error];
      }else{
        property.Errors = [];//quick audit has no p.ImportStatus
      }
      for (let i = 1; i <= 8; i++) {
        let season = GetSeason(p, i);
        if (season.StartDate) {
          property.SetSeasonStartDate(i, new DateTime(season.StartDate));
        } else {
          property.SetSeasonStartDate(i, null);
        }
        if (season.EndDate) {
          property.SetSeasonEndDate(i, new DateTime(season.EndDate));
        } else {
          property.SetSeasonEndDate(i, null);
        }
        const price = season.ExpectedPrice ? season.ExpectedPrice : "-1";
        const ceiling =  season.Ceiling ? parseFloat(season.Ceiling) : null;
        property.SetSeasonPrice(i, parseFloat(price), season.Dynamic, ceiling);
        // property.Season1DateToCheck1 = new DateTime(p.Season1DateToCheck1);
        // property.Season2DateToCheck1 = new DateTime(p.Season2DateToCheck1);
        if(property.LoadedFromOriginal){
          property.SetSeasonCheckDays(i, season.DateToCheck1?new DateTime(season.DateToCheck1):null, season.DateToCheck2?new DateTime(season.DateToCheck2):null, season.DateToCheck3?new DateTime(season.DateToCheck3):null
          , season.DateToCheck4?new DateTime(season.DateToCheck4):null, season.DateToCheck5?new DateTime(season.DateToCheck5):null);
        }
        else{
          property.SetSeasonCheckDays(i, null, null, null, null, null);
        }
      }
      property.index = index;
      this.property.push(property)

    });
  }


  validateAllProperties(dateSelectionRule: CorporateDateRules.DateSelectionRule) {
    this.property.forEach((property) => {
      property.validate(dateSelectionRule, this.QuickAudit);
    })
  }
  applyDateRulesToPropertiesOnEntry(dateSelectionRule: CorporateDateRules.DateSelectionRule) {
    this.property.forEach((property) => {
      property.Information = [];
      property.Errors = [];
      property.Warnings=[];
      property.ValidateCeiling();
      property.applyDateRulesToProperty(dateSelectionRule);
    })
    this.validateAllProperties(dateSelectionRule);
  }

  reapplyDateRulesToProperties(startDate: DateTime, endDate: DateTime, dateSelectionRule: CorporateDateRules.DateSelectionRule, useOriginalSeasonOne: boolean) {
    this.property.forEach(property => {
      property.Information = [];
      property.Errors = [];
      property.Warnings=[];
      property.ResetSeasonsToOriginal();

      property.ValidateCeiling();
      if (property.AutoExtractSeasons) {
        if (useOriginalSeasonOne) {
          var firstValidStart = this.now().date;
          property.Season1ResetStartDate = property.Season1OriginalResetStartDate.toJsDate() < firstValidStart.toJsDate() ? firstValidStart : property.Season1OriginalResetStartDate;
          property.Season1ResetEndDate = property.Season1OriginalResetEndDate;
        }
        else {
          property.Season1ResetStartDate = startDate;
          property.Season1ResetEndDate = endDate;
        }
      }

      property.applyDateRulesToProperty(dateSelectionRule);
    });
    this.validateAllProperties(dateSelectionRule);
  }
  isAGDSSelected(): boolean {
    return this.AuditAmadeus ||
      this.AuditApollo ||
      this.AuditGalileo ||
      this.AuditSabre ||
      this.AuditWorldspan;
  }

}

export class Property {
  ValidateCeiling() {
    if (this.LoadedFromOriginal)
      return;//rerun, already found L or LL
    let areAllCeiling: boolean = null;
    for (let season = 1; season <= 8 ; season++) {
      const s = this.GetSeason(season);
      if (s.Ceiling != null ) {
        if(s.Ceiling<=0){
          this.Errors.push({Message:"Season " + season + " Ceiling is less than or equal to zero." })
        }
        else if (s.StartDate==null || s.EndDate==null) {
          this.Errors.push( { Message: "Season " + season + " Ceiling is set without the seasons start and end dates being set." });
        }
        else if ((s.ExpectedPrice == -1 || s.Dynamic==false) ) {
          this.Errors.push( { Message: "Season " + season + " Ceiling is set without a corresponding Dynamic value." });
        }
        else if (areAllCeiling===false) {
          this.Errors.push( { Message: "A Dynamic w/ceiling rate was found in Season " + season + ", but was not found in the earlier seasons." });
        }
        else if(areAllCeiling == null && s.StartDate!=null && s.EndDate!=null ){
          areAllCeiling = true;
        }
      }
      else if(s.StartDate!=null && s.EndDate!=null && (s.ExpectedPrice!=null &&
        ((s.ExpectedPrice>=0 && s.Dynamic)||(s.ExpectedPrice>0 && !s.Dynamic))
        )){
          if (areAllCeiling == null ) {
            areAllCeiling = false;
          }
          if (areAllCeiling === true ) {
            this.Errors.push( { Message: "A Dynamic w/ceiling rate was not found for Season " + season + ", but was found in the earlier seasons." });
          }
      }
    }
  }
  GetSeason(season: number):{StartDate:DateTime,EndDate:DateTime,Valid:boolean
    ,DateToCheck1:DateTime,DateToCheck2:DateTime,DateToCheck3:DateTime,DateToCheck4:DateTime,DateToCheck5:DateTime
    ,ExpectedPrice:number,Dynamic:boolean, Ceiling?:number,RestoreStart:DateTime} {
    switch (season) {
      case 1: return {
        StartDate: this.Season1StartDate,
        EndDate: this.Season1EndDate,
        Valid: this.Season1Valid,
        DateToCheck1: this.Season1DateToCheck1,
        DateToCheck2: this.Season1DateToCheck2,
        DateToCheck3: this.Season1DateToCheck3,
        DateToCheck4: this.Season1DateToCheck4,
        DateToCheck5: this.Season1DateToCheck5,
        ExpectedPrice: this.Season1ExpectedPrice,
        Dynamic: this.Season1Dynamic,
        Ceiling: this.Season1Ceiling,
        RestoreStart: this.Season1RestoreStartDate,
      };
      case 2: return {
        StartDate: this.Season2StartDate,
        EndDate: this.Season2EndDate,
        Valid: this.Season2Valid,
        DateToCheck1: this.Season2DateToCheck1,
        DateToCheck2: this.Season2DateToCheck2,
        DateToCheck3: this.Season2DateToCheck3,
        DateToCheck4: this.Season2DateToCheck4,
        DateToCheck5: this.Season2DateToCheck5,
        ExpectedPrice: this.Season2ExpectedPrice,
        Dynamic: this.Season2Dynamic,
        Ceiling: this.Season2Ceiling,
        RestoreStart: this.Season2RestoreStartDate,
     };
      case 3: return {
        StartDate: this.Season3StartDate,
        EndDate: this.Season3EndDate,
        Valid: this.Season3Valid,
        DateToCheck1: this.Season3DateToCheck1,
        DateToCheck2: this.Season3DateToCheck2,
        DateToCheck3: this.Season3DateToCheck3,
        DateToCheck4: this.Season3DateToCheck4,
        DateToCheck5: this.Season3DateToCheck5,
        ExpectedPrice: this.Season3ExpectedPrice,
        Dynamic: this.Season3Dynamic,
        Ceiling: this.Season3Ceiling,
        RestoreStart: this.Season3RestoreStartDate,
      };
      case 4: return {
        StartDate: this.Season4StartDate,
        EndDate: this.Season4EndDate,
        Valid: this.Season4Valid,
        DateToCheck1: this.Season4DateToCheck1,
        DateToCheck2: this.Season4DateToCheck2,
        DateToCheck3: this.Season4DateToCheck3,
        DateToCheck4: this.Season4DateToCheck4,
        DateToCheck5: this.Season4DateToCheck5,
        ExpectedPrice: this.Season4ExpectedPrice,
        Dynamic: this.Season4Dynamic,
        Ceiling: this.Season4Ceiling,
        RestoreStart: this.Season4RestoreStartDate,
     };
      case 5: return {
        StartDate: this.Season5StartDate,
        EndDate: this.Season5EndDate,
        Valid: this.Season5Valid,
        DateToCheck1: this.Season5DateToCheck1,
        DateToCheck2: this.Season5DateToCheck2,
        DateToCheck3: this.Season5DateToCheck3,
        DateToCheck4: this.Season5DateToCheck4,
        DateToCheck5: this.Season5DateToCheck5,
        ExpectedPrice: this.Season5ExpectedPrice,
        Dynamic: this.Season5Dynamic,
        Ceiling: this.Season5Ceiling,
        RestoreStart: this.Season5RestoreStartDate,
      };
      case 6: return {
        StartDate: this.Season6StartDate,
        EndDate: this.Season6EndDate,
        Valid: this.Season6Valid,
        DateToCheck1: this.Season6DateToCheck1,
        DateToCheck2: this.Season6DateToCheck2,
        DateToCheck3: this.Season6DateToCheck3,
        DateToCheck4: this.Season6DateToCheck4,
        DateToCheck5: this.Season6DateToCheck5,
        ExpectedPrice: this.Season6ExpectedPrice,
        Dynamic: this.Season6Dynamic,
        Ceiling: this.Season6Ceiling,
        RestoreStart: this.Season6RestoreStartDate,
      };
      case 7: return {
        StartDate: this.Season7StartDate,
        EndDate: this.Season7EndDate,
        Valid: this.Season7Valid,
        DateToCheck1: this.Season7DateToCheck1,
        DateToCheck2: this.Season7DateToCheck2,
        DateToCheck3: this.Season7DateToCheck3,
        DateToCheck4: this.Season7DateToCheck4,
        DateToCheck5: this.Season7DateToCheck5,
        ExpectedPrice: this.Season7ExpectedPrice,
        Dynamic: this.Season7Dynamic,
        Ceiling: this.Season7Ceiling,
        RestoreStart: this.Season7RestoreStartDate,
      };
      case 8: return {
        StartDate: this.Season8StartDate,
        EndDate: this.Season8EndDate,
        Valid: this.Season8Valid,
        DateToCheck1: this.Season8DateToCheck1,
        DateToCheck2: this.Season8DateToCheck2,
        DateToCheck3: this.Season8DateToCheck3,
        DateToCheck4: this.Season8DateToCheck4,
        DateToCheck5: this.Season8DateToCheck5,
        ExpectedPrice: this.Season8ExpectedPrice,
        Dynamic: this.Season8Dynamic,
        Ceiling: this.Season8Ceiling,
        RestoreStart: this.Season8RestoreStartDate,
      }
    }
  }

  static copy(dat: Property): Property {
    let n: any = { ...dat };
    n.__proto__ = (<any>dat).__proto__;
    n.Errors = [];
    n.Information = [];
    n.Warnings = [];
    dat.Errors.forEach(e => n.Errors.push(e));
    dat.Information.forEach(e => n.Information.push(e));
    dat.Warnings.forEach(e => n.Warnings.push(e));
    return n;
  }
  constructor() {
    this.ProcessAmadeus = false;
    this.ProcessApollo = false;
    this.ProcessGalileo = false;
    this.ProcessSabre = false;
    this.ProcessWorldspan = false;
    this.AutoExtractSeasons = false;
    this.LRA = false;
    this.IsExtractedDateSet = false;
    this.Season1Valid = false;
    this.Season1Dynamic = false;
    this.Season2Valid = false;
    this.Season2Dynamic = false;
    this.Season3Valid = false;
    this.Season3Dynamic = false;
    this.Season4Valid = false;
    this.Season4Dynamic = false;
    this.Season5Valid = false;
    this.Season5Dynamic = false;
    this.Season6Valid = false;
    this.Season6Dynamic = false;
    this.Season7Valid = false;
    this.Season7Dynamic = false;
    this.Season8Valid = false;
    this.Season8Dynamic = false;
    this.Season1Ceiling = null;
    this.Season2Ceiling = null;
    this.Season3Ceiling = null;
    this.Season4Ceiling = null;
    this.Season5Ceiling = null;
    this.Season6Ceiling = null;
    this.Season7Ceiling = null;
    this.Season8Ceiling = null;
  }
  now: () => DateTime = () => { return DateTime.now };

  HotelChainCode: string = "";
  ParentHotelName: string = "";
  HotelCRSPropertyCode: string = "";
  PropertyName: string = "";
  PropertyAddress: string = "";
  PropertyCity: string = "";
  PropertyStateProvince: string = "";
  PropertyPostalCode: string = "";
  PropertyCountry: string = "";
  PropertyPhone: string = "";
  ContactName: string = "";
  ContactEMail: string = "";
  ProcessAmadeus: boolean;
  ProcessApollo: boolean;
  ProcessGalileo: boolean;
  ProcessSabre: boolean;
  ProcessWorldspan: boolean;
  AmadeusChainCode: string = "";
  AmadeusPropCode: string = "";
  AmadeusRateAccessCode: string = "";
  ApolloChainCode: string = "";
  ApolloPropCode: string = "";
  ApolloRateAccessCode: string = "";
  GalileoChainCode: string = "";
  GalileoPropCode: string = "";
  GalileoRateAccessCode: string = "";
  SabreChainCode: string = "";
  SabrePropCode: string = "";
  SabreRateAccessCode: string = "";
  WorldspanChainCode: string = "";
  WorldspanPropCode: string = "";
  WorldspanRateAccessCode: string = "";
  RateCurrency: string = "";
  AutoExtractSeasons: boolean;
  RoomType: string = "";
  LRA: boolean;
  EditEmail: boolean;
  BidAmenityBreakfast: string ="";
  BidAmenityInternet: string= "";
  BidAmenityParking: string = "";
  BidAmenityAirport: string = "";
  BidAmenityLocalShuttle: string = "";
  BidPolicyCancellation: string = "";

  IsExtractedDateSet: boolean;
  Season1ResetStartDate: DateTime;
  Season1ResetEndDate: DateTime;
  Season1OriginalResetStartDate: DateTime;
  Season1OriginalResetEndDate: DateTime;

  Season1OriginalStartDate: DateTime;
  Season1OriginalEndDate: DateTime;
  //Season1TextStartDate: string="";
  //Season1TextEndDate: string="";
  Season1StartDate: DateTime;
  Season1EndDate: DateTime;
  Season1Valid: boolean;
  Season1DateToCheck1: DateTime;
  Season1DateToCheck2: DateTime;
  Season1DateToCheck3: DateTime;
  Season1DateToCheck4: DateTime;
  Season1DateToCheck5: DateTime;
  Season1ExpectedPrice: number;
  Season1Dynamic: boolean;
  Season1Ceiling?: number = null;
  Season2OriginalStartDate: DateTime;
  Season2OriginalEndDate: DateTime;
  //Season2TextStartDate: string="";
  //Season2TextEndDate: string="";
  Season2StartDate: DateTime;
  Season2EndDate: DateTime;
  Season2Valid: boolean;
  Season2DateToCheck1: DateTime;
  Season2DateToCheck2: DateTime;
  Season2DateToCheck3: DateTime;
  Season2DateToCheck4: DateTime;
  Season2DateToCheck5: DateTime;
  Season2ExpectedPrice: number;
  Season2Dynamic: boolean;
  Season2Ceiling?: number = null;
  Season3OriginalStartDate: DateTime;
  Season3OriginalEndDate: DateTime;
  //Season3TextStartDate: string="";
  //Season3TextEndDate: string="";
  Season3StartDate: DateTime;
  Season3EndDate: DateTime;
  Season3Valid: boolean;
  Season3DateToCheck1: DateTime;
  Season3DateToCheck2: DateTime;
  Season3DateToCheck3: DateTime;
  Season3DateToCheck4: DateTime;
  Season3DateToCheck5: DateTime;
  Season3ExpectedPrice: number;
  Season3Dynamic: boolean;
  Season3Ceiling?: number = null;
  Season4OriginalStartDate: DateTime;
  Season4OriginalEndDate: DateTime;
  //Season4TextStartDate: string="";
  //Season4TextEndDate: string="";
  Season4StartDate: DateTime;
  Season4EndDate: DateTime;
  Season4Valid: boolean;
  Season4DateToCheck1: DateTime;
  Season4DateToCheck2: DateTime;
  Season4DateToCheck3: DateTime;
  Season4DateToCheck4: DateTime;
  Season4DateToCheck5: DateTime;
  Season4ExpectedPrice: number;
  Season4Dynamic: boolean;
  Season4Ceiling?: number = null;
  Season5OriginalStartDate: DateTime;
  Season5OriginalEndDate: DateTime;
  //Season5TextStartDate: string="";
  //Season5TextEndDate: string="";
  Season5StartDate: DateTime;
  Season5EndDate: DateTime;
  Season5Valid: boolean;
  Season5DateToCheck1: DateTime;
  Season5DateToCheck2: DateTime;
  Season5DateToCheck3: DateTime;
  Season5DateToCheck4: DateTime;
  Season5DateToCheck5: DateTime;
  Season5ExpectedPrice: number;
  Season5Dynamic: boolean;
  Season5Ceiling?: number = null;
  Season6OriginalStartDate: DateTime;
  Season6OriginalEndDate: DateTime;
  //Season6TextStartDate: string="";
  //Season6TextEndDate: string="";
  Season6StartDate: DateTime;
  Season6EndDate: DateTime;
  Season6Valid: boolean;
  Season6DateToCheck1: DateTime;
  Season6DateToCheck2: DateTime;
  Season6DateToCheck3: DateTime;
  Season6DateToCheck4: DateTime;
  Season6DateToCheck5: DateTime;
  Season6ExpectedPrice: number;
  Season6Dynamic: boolean;
  Season6Ceiling?: number = null;
  Season7OriginalStartDate: DateTime;
  Season7OriginalEndDate: DateTime;
  //Season7TextStartDate: string="";
  //Season7TextEndDate: string="";
  Season7StartDate: DateTime;
  Season7EndDate: DateTime;
  Season7Valid: boolean;
  Season7DateToCheck1: DateTime;
  Season7DateToCheck2: DateTime;
  Season7DateToCheck3: DateTime;
  Season7DateToCheck4: DateTime;
  Season7DateToCheck5: DateTime;
  Season7ExpectedPrice: number;
  Season7Dynamic: boolean;
  Season7Ceiling?: number = null;
  Season8OriginalStartDate: DateTime;
  Season8OriginalEndDate: DateTime;
  //Season8TextStartDate: string="";
  //Season8TextEndDate: string="";
  Season8StartDate: DateTime;
  Season8EndDate: DateTime;
  Season8Valid: boolean;
  Season8DateToCheck1: DateTime;
  Season8DateToCheck2: DateTime;
  Season8DateToCheck3: DateTime;
  Season8DateToCheck4: DateTime;
  Season8DateToCheck5: DateTime;
  Season8ExpectedPrice: number;
  Season8Dynamic: boolean;
  Season8Ceiling?: number = null;
  TempAuditPropertyID: string = "";
  LoadedFromOriginal: boolean;
  OriginalAuditPropertyID: string = "";

  Errors: Error[] = [];
  Warnings: Warning[] = [];
  Information: Info[] = [];

  index: number;
  Season1OriginalExpectedPrice: number;
  Season2OriginalExpectedPrice: number;
  Season3OriginalExpectedPrice: number;
  Season4OriginalExpectedPrice: number;
  Season5OriginalExpectedPrice: number;
  Season6OriginalExpectedPrice: number;
  Season7OriginalExpectedPrice: number;
  Season8OriginalExpectedPrice: number;

  Season1OriginalDynamic: boolean;
  Season2OriginalDynamic: boolean;
  Season3OriginalDynamic: boolean;
  Season4OriginalDynamic: boolean;
  Season5OriginalDynamic: boolean;
  Season6OriginalDynamic: boolean;
  Season7OriginalDynamic: boolean;
  Season8OriginalDynamic: boolean;

  Season1OriginalCeiling?: number = null;
  Season2OriginalCeiling?: number = null;
  Season3OriginalCeiling?: number = null;
  Season4OriginalCeiling?: number = null;
  Season5OriginalCeiling?: number = null;
  Season6OriginalCeiling?: number = null;
  Season7OriginalCeiling?: number = null;
  Season8OriginalCeiling?: number = null;

  //use Resotre Date to display when Start date was in the past and got changed
  Season1RestoreStartDate: DateTime;
  Season2RestoreStartDate: DateTime;
  Season3RestoreStartDate: DateTime;
  Season4RestoreStartDate: DateTime;
  Season5RestoreStartDate: DateTime;
  Season6RestoreStartDate: DateTime;
  Season7RestoreStartDate: DateTime;
  Season8RestoreStartDate: DateTime;


  public checkThatGDSPropertiesAreEntered(amadeus:boolean, apollo:boolean, galileo:boolean, sabre:boolean, worldspan:boolean):void{
    let baseMessage = " data incomplete or invalid rate access code for hotel " + this.PropertyName;
    let validatations =[
      { test: () => (!this.ValidateGDSEntries(amadeus,this.AmadeusChainCode, this.AmadeusPropCode, this.AmadeusRateAccessCode,3) ), message: "Amadeus" + baseMessage  },
      { test: () => (!this.ValidateGDSEntries(apollo,this.ApolloChainCode, this.ApolloPropCode, this.ApolloRateAccessCode,6,2) ), message: "Apollo" + baseMessage  },
      { test: () => (!this.ValidateGDSEntries(galileo,this.GalileoChainCode, this.GalileoPropCode, this.GalileoRateAccessCode,6,2) ), message: "Galileo" + baseMessage  },
      { test: () => (!this.ValidateGDSEntries(sabre,this.SabreChainCode, this.SabrePropCode, this.SabreRateAccessCode,3) ), message: "Sabre" + baseMessage  },
      { test: () => (!this.ValidateGDSEntries(worldspan,this.WorldspanChainCode, this.WorldspanPropCode, this.WorldspanRateAccessCode,7) ), message: "Worldspan" + baseMessage  },
    ]
    validatations.forEach(v => {
      if(v.test()){
        throw v.message;
      }
    });
  }
  ValidateGDSEntries(audit:boolean, chainCode:string, propertyCode:string, rateAccessCode:string, maxRac?:number,minRac?:number){
    if(audit){
      minRac = minRac?minRac:3;
      if(!chainCode || chainCode.trim().length<2 ) return false;
      if(!propertyCode || propertyCode.trim().length<1 ) return false;
      if(!rateAccessCode || rateAccessCode.trim().length<minRac || rateAccessCode.trim().length>10 ) return false;
      if(maxRac && rateAccessCode.trim().length>maxRac ) return false;
    }
    return true;
  }
  public MoveSeason(toSeason: number, fromSeason: number): void {
    if (toSeason >= 1 && toSeason <= 8 && fromSeason >= 1 && fromSeason <= 8) {
      if (this.IsSeasonValid(fromSeason)) {
        var season = this.GetSeason(fromSeason )
        this.SetSeasonValid(toSeason, true);
        this.SetSeasonStartDate(toSeason, season.StartDate);
        this.SetSeasonRestoreStartDate(toSeason ,season.RestoreStart)
        this.SetSeasonEndDate(toSeason, season.EndDate);
        this.SetSeasonPrice(toSeason, season.ExpectedPrice, season.Dynamic, season.Ceiling);
        this.SetSeasonCheckDays(toSeason,season.DateToCheck1, season.DateToCheck2, season.DateToCheck3, season.DateToCheck4, season.DateToCheck5)
      }
      else {
        this.SetSeasonValid(toSeason, false);
        this.SetSeasonStartDate(toSeason, null);
        this.SetSeasonEndDate(toSeason, null);
        this.SetSeasonPrice(toSeason, 0.0, false, null);
        this.SetSeasonCheckDays(toSeason,null,null,null,null,null)

      }
      this.SetSeasonValid(fromSeason, false);
      this.SetSeasonStartDate(fromSeason, null);
      this.SetSeasonEndDate(fromSeason, null);
      this.SetSeasonPrice(fromSeason, 0.0, false, null);
      this.SetSeasonCheckDays(fromSeason,null,null,null,null,null)

    }
  }
  public SetSeasonPrice(season: number, expectedPrice: number, dynamicPrice: boolean, ceiling?: number): void {
    switch (season) {
      case 1:
        this.Season1Dynamic = dynamicPrice;
        this.Season1ExpectedPrice = expectedPrice;
        this.Season1Ceiling = ceiling;
        break;
      case 2:
        this.Season2Dynamic = dynamicPrice;
        this.Season2ExpectedPrice = expectedPrice;
        this.Season2Ceiling = ceiling;
        break;
      case 3:
        this.Season3Dynamic = dynamicPrice;
        this.Season3ExpectedPrice = expectedPrice;
        this.Season3Ceiling = ceiling;
        break;
      case 4:
        this.Season4Dynamic = dynamicPrice;
        this.Season4ExpectedPrice = expectedPrice;
        this.Season4Ceiling = ceiling;
        break;
      case 5:
        this.Season5Dynamic = dynamicPrice;
        this.Season5ExpectedPrice = expectedPrice;
        this.Season5Ceiling = ceiling;
        break;
      case 6:
        this.Season6Dynamic = dynamicPrice;
        this.Season6ExpectedPrice = expectedPrice;
        this.Season6Ceiling = ceiling;
        break;
      case 7:
        this.Season7Dynamic = dynamicPrice;
        this.Season7ExpectedPrice = expectedPrice;
        this.Season7Ceiling = ceiling;
        break;
      case 8:
        this.Season8Dynamic = dynamicPrice;
        this.Season8ExpectedPrice = expectedPrice;
        this.Season8Ceiling = ceiling;
        break;
    }
  }

  public SetSeasonValid(season: number, set: boolean): void {
    switch (season) {
      case 1:
        this.Season1Valid = set;
        break;
      case 2:
        this.Season2Valid = set;
        break;
      case 3:
        this.Season3Valid = set;
        break;
      case 4:
        this.Season4Valid = set;
        break;
      case 5:
        this.Season5Valid = set;
        break;
      case 6:
        this.Season6Valid = set;
        break;
      case 7:
        this.Season7Valid = set;
        break;
      case 8:
        this.Season8Valid = set;
        break;
    }
  }
  public IsSeasonValid(season: number): boolean {
    switch (season) {
      case 1:
        return this.Season1Valid;
      case 2:
        return this.Season2Valid;
      case 3:
        return this.Season3Valid;
      case 4:
        return this.Season4Valid;
      case 5:
        return this.Season5Valid;
      case 6:
        return this.Season6Valid;
      case 7:
        return this.Season7Valid;
      case 8:
        return this.Season8Valid;
    }
    return false;
  }
  public SetSeasonStartDate(season: number, theDateTime: DateTime): void {
    switch (season) {
      case 1:
        this.Season1StartDate = theDateTime;
        break;
      case 2:
        this.Season2StartDate = theDateTime;
        break;
      case 3:
        this.Season3StartDate = theDateTime;
        break;
      case 4:
        this.Season4StartDate = theDateTime;
        break;
      case 5:
        this.Season5StartDate = theDateTime;
        break;
      case 6:
        this.Season6StartDate = theDateTime;
        break;
      case 7:
        this.Season7StartDate = theDateTime;
        break;
      case 8:
        this.Season8StartDate = theDateTime;
        break;
    }
  }
  public SetSeasonRestoreStartDate(season: number, originalStart: DateTime): void {
    switch (season) {
      case 1:
        this.Season1RestoreStartDate = originalStart;
        break;
      case 2:
        this.Season2RestoreStartDate = originalStart;
        break;
      case 3:
        this.Season3RestoreStartDate = originalStart;
        break;
      case 4:
        this.Season4RestoreStartDate = originalStart;
        break;
      case 5:
        this.Season5RestoreStartDate = originalStart;
        break;
      case 6:
        this.Season6RestoreStartDate = originalStart;
        break;
      case 7:
        this.Season7RestoreStartDate = originalStart;
        break;
      case 8:
        this.Season8RestoreStartDate = originalStart;
        break;
    }
  }
  public SetSeasonEndDate(season: number, theDateTime: DateTime): void {
    switch (season) {
      case 1:
        this.Season1EndDate = theDateTime;
        break;
      case 2:
        this.Season2EndDate = theDateTime;
        break;
      case 3:
        this.Season3EndDate = theDateTime;
        break;
      case 4:
        this.Season4EndDate = theDateTime;
        break;
      case 5:
        this.Season5EndDate = theDateTime;
        break;
      case 6:
        this.Season6EndDate = theDateTime;
        break;
      case 7:
        this.Season7EndDate = theDateTime;
        break;
      case 8:
        this.Season8EndDate = theDateTime;
        break;
    }
  }
  public GetSeasonEndDate(season: number): DateTime {
    switch (season) {
      case 1:
        return this.Season1EndDate;
      case 2:
        return this.Season2EndDate;
      case 3:
        return this.Season3EndDate;
      case 4:
        return this.Season4EndDate;
      case 5:
        return this.Season5EndDate;
      case 6:
        return this.Season6EndDate;
      case 7:
        return this.Season7EndDate;
      case 8:
        return this.Season8EndDate;
    }
    return null;
  }

  validate(dateSelectionRule: CorporateDateRules.DateSelectionRule, quickAudit: boolean) {
    let importValidator: ImportValidator = new ImportValidator();
    importValidator.Validate(dateSelectionRule, this, quickAudit)
  }
  applyDateRulesToProperty(dateSelectionRule: CorporateDateRules.DateSelectionRule) {
    var seasonExtracted: boolean = true;
    if (this.IsExtractedDateSet) {
      try {
        this.AutoExtractSeasons = true;
        var firstValidStart = AddDaysToDate(this.now(), 1);
        var startDate = this.Season1OriginalStartDate;
        if (this.Season1ResetStartDate != null) {
          startDate = this.Season1ResetStartDate;
        }
        this.Season1StartDate = startDate.toJsDate() < firstValidStart.toJsDate() ? firstValidStart : startDate;
        var endDate = this.Season1OriginalEndDate;
        if (this.Season1ResetEndDate != null) {
          endDate = this.Season1ResetEndDate;
        }
        this.Season1EndDate = endDate;
        CorporateDateRules.ExtractSeasons(this, dateSelectionRule, false);
        CorporateDateRules.ExtractCheckDates(this, dateSelectionRule, false)
      }
      catch (exception) {
        seasonExtracted = false;
        confirm(format("Error Extracting Seasons -> {0}\r\n{1}", this.PropertyName, exception.Message));
      }
    }
    else {
      this.ResetSeasonsToOriginal();
    }
  }

  SetSeasonCheckDays(season: number, date1: DateTime, date2: DateTime, date3: DateTime, date4: DateTime, date5: DateTime) {
    switch (season) {
      case 1:
        this.Season1DateToCheck1 = date1;
        this.Season1DateToCheck2 = date2;
        this.Season1DateToCheck3 = date3;
        this.Season1DateToCheck4 = date4;
        this.Season1DateToCheck5 = date5;
        break;
      case 2:
        this.Season2DateToCheck1 = date1;
        this.Season2DateToCheck2 = date2;
        this.Season2DateToCheck3 = date3;
        this.Season2DateToCheck4 = date4;
        this.Season2DateToCheck5 = date5;
        break;
      case 3:
        this.Season3DateToCheck1 = date1;
        this.Season3DateToCheck2 = date2;
        this.Season3DateToCheck3 = date3;
        this.Season3DateToCheck4 = date4;
        this.Season3DateToCheck5 = date5;
        break;
      case 4:
        this.Season4DateToCheck1 = date1;
        this.Season4DateToCheck2 = date2;
        this.Season4DateToCheck3 = date3;
        this.Season4DateToCheck4 = date4;
        this.Season4DateToCheck5 = date5;
        break;
      case 5:
        this.Season5DateToCheck1 = date1;
        this.Season5DateToCheck2 = date2;
        this.Season5DateToCheck3 = date3;
        this.Season5DateToCheck4 = date4;
        this.Season5DateToCheck5 = date5;
        break;
      case 6:
        this.Season6DateToCheck1 = date1;
        this.Season6DateToCheck2 = date2;
        this.Season6DateToCheck3 = date3;
        this.Season6DateToCheck4 = date4;
        this.Season6DateToCheck5 = date5;
        break;
      case 7:
        this.Season7DateToCheck1 = date1;
        this.Season7DateToCheck2 = date2;
        this.Season7DateToCheck3 = date3;
        this.Season7DateToCheck4 = date4;
        this.Season7DateToCheck5 = date5;
        break;
      case 8:
        this.Season8DateToCheck1 = date1;
        this.Season8DateToCheck2 = date2;
        this.Season8DateToCheck3 = date3;
        this.Season8DateToCheck4 = date4;
        this.Season8DateToCheck5 = date5;
        break;
    }
  }

  truncateOversizedString(maxLength: number, p: Property, propName: string) {
    let prop: string = p[propName] as string;
    if (prop) {
      if (prop.length > maxLength) {
        let info: Info = { Message: "Truncated " + propName + '  "' + prop + '" ' + ' to length ' + maxLength }
        p[propName] = prop.substr(0, maxLength);
        p.Information.push(info);
      }
    }
  }

  truncateOversizedStrings() {
    let p: Property = this;
    this.truncateOversizedString(10, p, "CurrencyCode");
    this.truncateOversizedString(10, p, "AmadeusChainCode");
    this.truncateOversizedString(10, p, "AmadeusPropCode");
    this.truncateOversizedString(10, p, "AmadeusRateAccessCode");
    this.truncateOversizedString(10, p, "ApolloChainCode");
    this.truncateOversizedString(10, p, "ApolloPropCode");
    this.truncateOversizedString(10, p, "ApolloRateAccessCode");
    this.truncateOversizedString(10, p, "GalileoChainCode");
    this.truncateOversizedString(10, p, "GalileoPropCode");
    this.truncateOversizedString(10, p, "GalileoRateAccessCode");
    this.truncateOversizedString(10, p, "SabreChainCode");
    this.truncateOversizedString(10, p, "SabrePropCode");
    this.truncateOversizedString(10, p, "SabreRateAccessCode");
    this.truncateOversizedString(10, p, "WorldspanChainCode");
    this.truncateOversizedString(10, p, "WorldspanPropCode");
    this.truncateOversizedString(10, p, "WorldspanRateAccessCode");
    this.truncateOversizedString(10, p, "HotelChainCode");
    this.truncateOversizedString(20, p, "HotelCRSPropertyCode");
    this.truncateOversizedString(255, p, "ParentHotelChain");
    this.truncateOversizedString(255, p, "ParentHotelName");
    this.truncateOversizedString(255, p, "PropertyAddress");
    this.truncateOversizedString(25, p, "PropertyCity");
    this.truncateOversizedString(255, p, "ContactEMail");
    this.truncateOversizedString(255, p, "ContactName");
    this.truncateOversizedString(50, p, "PropertyContactPhone");
    this.truncateOversizedString(20, p, "PropertyCountry");
    this.truncateOversizedString(255, p, "PropertyName");
    this.truncateOversizedString(25, p, "PropertyPostalCode");
    this.truncateOversizedString(25, p, "PropertyStateProvince");
    this.truncateOversizedString(25, p, "RoomType");
  }

  static PrepareDates(p: Property) {

    p.Season1ResetStartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season1ResetStartDate);
    p.Season1ResetEndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season1ResetEndDate);

    p.Season1OriginalStartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season1OriginalStartDate);
    p.Season2OriginalStartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season2OriginalStartDate);
    p.Season3OriginalStartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season3OriginalStartDate);
    p.Season4OriginalStartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season4OriginalStartDate);
    p.Season5OriginalStartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season5OriginalStartDate);
    p.Season6OriginalStartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season6OriginalStartDate);
    p.Season7OriginalStartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season7OriginalStartDate);
    p.Season8OriginalStartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season8OriginalStartDate);

    p.Season1OriginalEndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season1OriginalEndDate);
    p.Season2OriginalEndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season2OriginalEndDate);
    p.Season3OriginalEndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season3OriginalEndDate);
    p.Season4OriginalEndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season4OriginalEndDate);
    p.Season5OriginalEndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season5OriginalEndDate);
    p.Season6OriginalEndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season6OriginalEndDate);
    p.Season7OriginalEndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season7OriginalEndDate);
    p.Season8OriginalEndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season8OriginalEndDate);

    p.Season1StartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season1StartDate);
    p.Season2StartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season2StartDate);
    p.Season3StartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season3StartDate);
    p.Season4StartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season4StartDate);
    p.Season5StartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season5StartDate);
    p.Season6StartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season6StartDate);
    p.Season7StartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season7StartDate);
    p.Season8StartDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season8StartDate);
    p.Season1EndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season1EndDate);
    p.Season2EndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season2EndDate);
    p.Season3EndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season3EndDate);
    p.Season4EndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season4EndDate);
    p.Season5EndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season5EndDate);
    p.Season6EndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season6EndDate);
    p.Season7EndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season7EndDate);
    p.Season8EndDate = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season8EndDate);
    p.Season1DateToCheck1 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season1DateToCheck1);
    p.Season1DateToCheck2 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season1DateToCheck2);
    p.Season1DateToCheck3 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season1DateToCheck3);
    p.Season1DateToCheck4 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season1DateToCheck4);
    p.Season1DateToCheck5 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season1DateToCheck5);
    p.Season2DateToCheck1 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season2DateToCheck1);
    p.Season2DateToCheck2 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season2DateToCheck2);
    p.Season2DateToCheck3 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season2DateToCheck3);
    p.Season2DateToCheck4 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season2DateToCheck4);
    p.Season2DateToCheck5 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season2DateToCheck5);
    p.Season3DateToCheck1 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season3DateToCheck1);
    p.Season3DateToCheck2 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season3DateToCheck2);
    p.Season3DateToCheck3 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season3DateToCheck3);
    p.Season3DateToCheck4 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season3DateToCheck4);
    p.Season3DateToCheck5 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season3DateToCheck5);
    p.Season4DateToCheck1 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season4DateToCheck1);
    p.Season4DateToCheck2 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season4DateToCheck2);
    p.Season4DateToCheck3 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season4DateToCheck3);
    p.Season4DateToCheck4 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season4DateToCheck4);
    p.Season4DateToCheck5 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season4DateToCheck5);
    p.Season5DateToCheck1 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season5DateToCheck1);
    p.Season5DateToCheck2 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season5DateToCheck2);
    p.Season5DateToCheck3 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season5DateToCheck3);
    p.Season5DateToCheck4 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season5DateToCheck4);
    p.Season5DateToCheck5 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season5DateToCheck5);
    p.Season6DateToCheck1 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season6DateToCheck1);
    p.Season6DateToCheck2 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season6DateToCheck2);
    p.Season6DateToCheck3 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season6DateToCheck3);
    p.Season6DateToCheck4 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season6DateToCheck4);
    p.Season6DateToCheck5 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season6DateToCheck5);
    p.Season7DateToCheck1 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season7DateToCheck1);
    p.Season7DateToCheck2 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season7DateToCheck2);
    p.Season7DateToCheck3 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season7DateToCheck3);
    p.Season7DateToCheck4 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season7DateToCheck4);
    p.Season7DateToCheck5 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season7DateToCheck5);
    p.Season8DateToCheck1 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season8DateToCheck1);
    p.Season8DateToCheck2 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season8DateToCheck2);
    p.Season8DateToCheck3 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season8DateToCheck3);
    p.Season8DateToCheck4 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season8DateToCheck4);
    p.Season8DateToCheck5 = <any>RIAHelper.BuildWsDateFromDateTimeForRateAudit(p.Season8DateToCheck5);

  }
  static GetSeason(data: Property, season: number) :{StartDate:DateTime,EndDate:DateTime,Valid:boolean
    ,DateToCheck1:DateTime,DateToCheck2:DateTime,DateToCheck3:DateTime,DateToCheck4:DateTime,DateToCheck5:DateTime
    ,ExpectedPrice:number,Dynamic:boolean, Ceiling?:number,RestoreStart:DateTime}{
    return data.GetSeason(season);

  }

  SaveOriginalSeasonsInfo() {
    this.Season1OriginalStartDate = this.Season1StartDate;
    this.Season1OriginalEndDate = this.Season1EndDate;
    this.Season1OriginalResetStartDate = this.Season1StartDate;
    this.Season1OriginalResetEndDate = this.Season1EndDate;

    this.Season2OriginalStartDate = this.Season2StartDate;
    this.Season2OriginalEndDate = this.Season2EndDate;
    this.Season3OriginalStartDate = this.Season3StartDate;
    this.Season3OriginalEndDate = this.Season3EndDate;
    this.Season4OriginalStartDate = this.Season4StartDate;
    this.Season4OriginalEndDate = this.Season4EndDate;
    this.Season5OriginalStartDate = this.Season5StartDate;
    this.Season5OriginalEndDate = this.Season5EndDate;
    this.Season6OriginalStartDate = this.Season6StartDate;
    this.Season6OriginalEndDate = this.Season6EndDate;
    this.Season7OriginalStartDate = this.Season7StartDate;
    this.Season7OriginalEndDate = this.Season7EndDate;
    this.Season8OriginalStartDate = this.Season8StartDate;
    this.Season8OriginalEndDate = this.Season8EndDate;
    this.Season1OriginalExpectedPrice = this.Season1ExpectedPrice;
    this.Season2OriginalExpectedPrice = this.Season2ExpectedPrice;
    this.Season3OriginalExpectedPrice = this.Season3ExpectedPrice;
    this.Season4OriginalExpectedPrice = this.Season4ExpectedPrice;
    this.Season5OriginalExpectedPrice = this.Season5ExpectedPrice;
    this.Season6OriginalExpectedPrice = this.Season6ExpectedPrice;
    this.Season7OriginalExpectedPrice = this.Season7ExpectedPrice;
    this.Season8OriginalExpectedPrice = this.Season8ExpectedPrice;

    this.Season1OriginalDynamic = this.Season1Dynamic;
    this.Season2OriginalDynamic = this.Season2Dynamic;
    this.Season3OriginalDynamic = this.Season3Dynamic;
    this.Season4OriginalDynamic = this.Season4Dynamic;
    this.Season5OriginalDynamic = this.Season5Dynamic;
    this.Season6OriginalDynamic = this.Season6Dynamic;
    this.Season7OriginalDynamic = this.Season7Dynamic;
    this.Season8OriginalDynamic = this.Season8Dynamic;

    this.Season1OriginalCeiling = this.Season1Ceiling;
    this.Season2OriginalCeiling = this.Season2Ceiling;
    this.Season3OriginalCeiling = this.Season3Ceiling;
    this.Season4OriginalCeiling = this.Season4Ceiling;
    this.Season5OriginalCeiling = this.Season5Ceiling;
    this.Season6OriginalCeiling = this.Season6Ceiling;
    this.Season7OriginalCeiling = this.Season7Ceiling;
    this.Season8OriginalCeiling = this.Season8Ceiling;
  }

  ResetSeasonsToOriginal() {
    this.Season1StartDate = this.Season1OriginalStartDate;
    this.Season1EndDate = this.Season1OriginalEndDate;

    this.Season2StartDate = this.Season2OriginalStartDate;
    this.Season2EndDate = this.Season2OriginalEndDate;

    this.Season3StartDate = this.Season3OriginalStartDate;
    this.Season3EndDate = this.Season3OriginalEndDate;

    this.Season4StartDate = this.Season4OriginalStartDate;
    this.Season4EndDate = this.Season4OriginalEndDate;

    this.Season5StartDate = this.Season5OriginalStartDate;
    this.Season5EndDate = this.Season5OriginalEndDate;

    this.Season6StartDate = this.Season6OriginalStartDate;
    this.Season6EndDate = this.Season6OriginalEndDate;

    this.Season7StartDate = this.Season7OriginalStartDate;
    this.Season7EndDate = this.Season7OriginalEndDate;

    this.Season8StartDate = this.Season8OriginalStartDate;
    this.Season8EndDate = this.Season8OriginalEndDate;
    this.Season1ExpectedPrice = this.Season1OriginalExpectedPrice;
    this.Season2ExpectedPrice = this.Season2OriginalExpectedPrice;
    this.Season3ExpectedPrice = this.Season3OriginalExpectedPrice;
    this.Season4ExpectedPrice = this.Season4OriginalExpectedPrice;
    this.Season5ExpectedPrice = this.Season5OriginalExpectedPrice;
    this.Season6ExpectedPrice = this.Season6OriginalExpectedPrice;
    this.Season7ExpectedPrice = this.Season7OriginalExpectedPrice;
    this.Season8ExpectedPrice = this.Season8OriginalExpectedPrice;
    this.Season1Dynamic = this.Season1OriginalDynamic;
    this.Season2Dynamic = this.Season2OriginalDynamic;
    this.Season3Dynamic = this.Season3OriginalDynamic;
    this.Season4Dynamic = this.Season4OriginalDynamic;
    this.Season5Dynamic = this.Season5OriginalDynamic;
    this.Season6Dynamic = this.Season6OriginalDynamic;
    this.Season7Dynamic = this.Season7OriginalDynamic;
    this.Season8Dynamic = this.Season8OriginalDynamic;

    this.Season1Ceiling = this.Season1OriginalCeiling;
    this.Season2Ceiling = this.Season2OriginalCeiling;
    this.Season3Ceiling = this.Season3OriginalCeiling;
    this.Season4Ceiling = this.Season4OriginalCeiling;
    this.Season5Ceiling = this.Season5OriginalCeiling;
    this.Season6Ceiling = this.Season6OriginalCeiling;
    this.Season7Ceiling = this.Season7OriginalCeiling;
    this.Season8Ceiling = this.Season8OriginalCeiling;

    this.Season1Valid = false;
    this.Season2Valid = false;
    this.Season3Valid = false;
    this.Season4Valid = false;
    this.Season5Valid = false;
    this.Season6Valid = false;
    this.Season7Valid = false;
    this.Season8Valid = false;
  }
  InitializeAfterUpload() {
    this.SaveOriginalSeasonsInfo();
    this.IsExtractedDateSet = CorporateDateRules.NumberOfSeasonsProvided(this) == 1;
    this.Season1ResetStartDate = null;
    this.Season1ResetEndDate = null;
  }
}//end Property

export interface ImportStatus {
  Errors: Errors;
  Warnings?: any;
}

export interface Errors {
  Error: Error[];
}

export interface Error {
  Message: string;
}
export class Warning {
  public Permanent?: boolean = false;
  public Message: string;
}
export class Info {
  public DateStamp?: DateTime;
  public Message: string;
}
export interface ImportResults {
  TotalPropertyCount: string;
  CustomerID: string;
  PreviousAuditTitle?: string;
  PreviousAuditID?: string;
  MatchPropertyCount?: string;
}

